/**
 * Validate if 2 date objects correspond to the same day.
 *
 * @param {Date} date1 - first Date object to be compared
 * @param {Date} date2 - second Date object to be compared
 */
const isSameDay = (date1: Date, date2: Date) =>
  date1.getDate() === date2.getDate() &&
  date1.getMonth() === date2.getMonth() &&
  date1.getFullYear() === date2.getFullYear();

export default isSameDay;
